import { render } from "./CommentsItem.vue?vue&type=template&id=9cd9a318&scoped=true"
import script from "./CommentsItem.vue?vue&type=script&lang=js"
export * from "./CommentsItem.vue?vue&type=script&lang=js"

import "./CommentsItem.vue?vue&type=style&index=0&id=9cd9a318&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd9a318"]])

export default __exports__